module.exports = __webpack_public_path__ + "img/board_title-zh.b14ecfd6.png";